import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ThemeProvider, createTheme } from "@mui/material";
import React from 'react';

export const myTheme = createTheme({
    components: {
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: 
                {
                    backgroundColor: "#47484d",
                },
            }
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    //color: "#444477",
                    textDecoration: "none",
                    ":hover": {
                        color: "#a86cff"
                    },
                },
            },
        },
    },
});

/*function isTypeOf<T>(jsonObject: object, instanceType: { new(): T; }): boolean {
    const instanceObject = new instanceType();
    for (const propertyName in instanceObject) {
        if (!Object.prototype.hasOwnProperty.call(jsonObject, propertyName)) {
            return false;
        }
    }
    return true;
};*/

createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeProvider theme={myTheme}>
            <App />
        </ThemeProvider>
    </React.StrictMode>
)
